import { connect } from 'react-redux';
import Loader from 'features/Loader/Loader';
import { getTodayTimeline } from 'features/timeline/ducks/timelineActions';
import React from 'react';
import Timeline from 'features/timeline/components';
import ActivityHeader from './ActivityHeader';
import HomeEmpty from '../HomeEmpty';
import './Activity.scss';

class Activity extends React.Component {
  componentDidMount() {
    this.props.getTodayTimeline();
  }

  render() {
    const { events, numberOfSessions, loading } = this.props;
    return (
      <section className="activity-side">
        <div className="activity">
          {!loading && events ? (
            <>
              <ActivityHeader numberOfSessions={numberOfSessions} />
              {events.length ? (
                <Timeline
                  events={events}
                  enableLoadButton={false}
                  isClientTimeline={false}
                />
              ) : (
                <HomeEmpty
                  title="No activity yet"
                  text="Your clients haven’t logged any activity yet"
                />
              )}
            </>
          ) : (
            <Loader />
          )}
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    events: state.timelineReducer.todayTimeline.events,
    numberOfSessions: state.timelineReducer.todayTimeline.numberOfSessions,
    loading: state.timelineReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getTodayTimeline: () => dispatch(getTodayTimeline())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Activity);
